import { Link } from 'react-router-dom';
import { useFavorites } from '../hooks/useFavorites';
import './EventCard.css';
import './OfertaCard.css';

const locationIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%23679509' stroke-width='2' stroke-linecap='round'%3E%3Cpath d='M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z'/%3E%3Ccircle cx='12' cy='10' r='3'/%3E%3C/svg%3E";
const arrowIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2.5' stroke-linecap='round'%3E%3Cline x1='5' y1='12' x2='19' y2='12'/%3E%3Cpolyline points='12 5 19 12 12 19'/%3E%3C/svg%3E";
const heartOutline = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2'%3E%3Cpath d='M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z'/%3E%3C/svg%3E";
const heartFilled = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='%23ef4444' stroke='%23ef4444' stroke-width='2'%3E%3Cpath d='M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z'/%3E%3C/svg%3E";

function pesos(valor) {
  return '$' + Number(valor || 0).toLocaleString('es-CO');
}

export default function OfertaCard({ id, slug, image, category, comercio, ciudad, titulo, precioOriginal, precioPromocional, porcentajeDescuento, tipo = 'empresa', urlAfiliado = null }) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const liked = id ? isFavorite(id) : false;
  // Las ofertas de marketing (cupones de afiliado) no tienen precio, ni stock, ni fechas
  const esMarketing = tipo === 'marketing';

  const handleFav = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (id) toggleFavorite(id);
  };

  const card = (
    <article
      className={`tarjeta-evento tarjeta-oferta${esMarketing ? ' tarjeta-oferta--marketing' : ''}`}
      data-url-afiliado={esMarketing ? (urlAfiliado || undefined) : undefined}
    >
      <div className="tarjeta-evento__image-wrap">
        <img src={image || '/imagenes/placeholder.jpg'} alt={titulo} width="400" height="210" loading="lazy" />
        {category && <span className="tarjeta-evento__badge">{category}</span>}
        {!esMarketing && porcentajeDescuento > 0 && (
          <span className="tarjeta-oferta__descuento">-{porcentajeDescuento}%</span>
        )}
        <button className={`tarjeta-evento__fav ${liked ? 'tarjeta-evento__fav--liked' : ''}`} onClick={handleFav}>
          <img src={liked ? heartFilled : heartOutline} alt="Favorito" />
        </button>
      </div>
      <div className="tarjeta-evento__content">
        <div className="tarjeta-evento__meta">
          {comercio && (
            <div className="tarjeta-evento__meta-line">
              <span className="tarjeta-oferta__comercio">{comercio}</span>
            </div>
          )}
          {ciudad && (
            <div className="tarjeta-evento__meta-line">
              <img className="tarjeta-evento__meta-icon tarjeta-evento__meta-icon--loc" src={locationIcon} alt="" />
              <span className="tarjeta-evento__meta-text">{ciudad}</span>
            </div>
          )}
        </div>
        <h4 className="tarjeta-evento__title">{titulo}</h4>
        <div className="tarjeta-evento__footer">
          <div>
            {esMarketing ? (
              <p className="tarjeta-oferta__ir-cupon">Ir al cupon</p>
            ) : (
              <>
                {precioOriginal && Number(precioOriginal) > Number(precioPromocional) && (
                  <p className="tarjeta-oferta__precio-original">{pesos(precioOriginal)}</p>
                )}
                <p className="tarjeta-evento__price-value">{pesos(precioPromocional)}</p>
              </>
            )}
          </div>
          <button className="tarjeta-evento__action">
            <img src={arrowIcon} alt="Ver detalle" />
          </button>
        </div>
      </div>
    </article>
  );

  if (slug) {
    return <Link to={`/ofertas/${slug}`} className="tarjeta-evento__link">{card}</Link>;
  }
  return card;
}
